import axios from "axios";
import url from "../utils/url";
import getError from "../utils/getError";

export const adminSendOtp = (data, afterAsync) => {
  axios
    .post(url + `/auth`, data)
    .then((res) => {
      afterAsync(true);
    })
    .catch((err) => {
      console.log(err.response);
      afterAsync(false);
    });
};

export const getCustomers = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/customers` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCategories = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/categories` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getHsCodes = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/hscodes` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getAssessments = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/cnf/assessment` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getMaterials = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/materials` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getOrders = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/orders` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getBookings = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/bookings` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getPurchasingList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getDelivery = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/delivery/list` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getDeliveries = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/deliveries` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getInvoices = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/v2/invoices` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getDueInvoiceStats = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/invoice/due/stats` + filters)
    .then((res) => {
      setData(res.data?.data || res.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCourierInvoices = (courier, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/v2/courier/invoices/${courier}` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCommercialSheets = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/cnf/sheet/commercial` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPackingList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/cnf/sheet/packing` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getDetailsSheet = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/cnf/sheet/detail` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getPISheet = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/cnf/sheet/pi` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const initiateDelivery = (filter, afterAsync) => {
  axios
    .post(url + `/delivery/initiate`, filter)
    .then((res) => {
      afterAsync(res.data?.data);
    })
    .catch((err) => {
      afterAsync(null);
    });
};

export const initiateDeliveryV2 = (filter, afterAsync) => {
  axios
    .post(url + `/v2/booking/prepare-invoice`, filter)
    .then((res) => {
      afterAsync(res.data?.data);
    })
    .catch((err) => {
      afterAsync(null);
    });
};

export const placeCourierBooking = (data, afterAsync) => {
  axios
    .post(url + `/courier`, data)
    .then((res) => {
      afterAsync(res.data?.data);
    })
    .catch((err) => {
      afterAsync(null);
    });
};

export const placeCourierSteadfastBooking = (data, afterAsync) => {
  axios
    .post(url + `/v2/courier/steadfast/${data.delivery_id}`, data)
    .then((res) => {
      afterAsync(res.data?.data);
    })
    .catch((err) => {
      afterAsync(null);
    });
};

export const placePartialBooking = (id, data, afterAsync) => {
  axios
    .post(url + `/v2/booking/partial/${id}`, data)
    .then((res) => {
      afterAsync(
        true,
        res.data?.message || "Partial booking placed successfully",
      );
    })
    .catch((err) => {
      afterAsync(false, getError(err));
    });
};

export const executeDelivery = (filter, afterAsync) => {
  axios
    .post(url + `/delivery/execute`, filter)
    .then((res) => {
      afterAsync(res.data?.data);
    })
    .catch((err) => {
      afterAsync(null);
    });
};
export const executeDeliveryV2 = (filter, afterAsync) => {
  axios
    .post(url + `/v2/booking/generate-invoice`, filter)
    .then((res) => {
      afterAsync(res.data?.data);
    })
    .catch((err) => {
      afterAsync(null);
    });
};
export const getTrackingList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/tracking/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getAdmins = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/admins` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getStatusList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/statuses` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getOrderReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/order/monthly` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getOrderProfitReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/profit/order` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getCoupons = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/coupons` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getShipmentStatusList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipment/statuses` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getPayable = (setData, filter) => {
  axios
    .post(url + `/payment/payable`, filter)
    .then((res) => {
      setData(res.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const allocateShipmentCarton = (id, data, afterPerform) => {
  axios
    .put(url + `/allocation/add-cartons/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const removeShipmentCarton = (id, data, afterPerform) => {
  axios
    .put(url + `/allocation/remove-cartons/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getProfile = (setData) => {
  axios
    .get(url + `/profile`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getMasterInvoice = (id, setData) => {
  axios
    .get(url + `/delivery/${id}`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getMasterInvoiceV2 = (id, setData) => {
  axios
    .get(url + `/v2/invoice/${id}`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const updateProfile = (data, afterPerform) => {
  axios
    .put(url + `/profile`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const reviewPayment = (id, data, afterPerform) => {
  axios
    .put(url + `/payment/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateShipPaymentStatus = (id, data, afterPerform) => {
  axios
    .put(url + `/v2/payment/${id}/status`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updateTracking = (id, data, afterPerform) => {
  axios
    .put(url + `/order/tracking/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updateShipment = (id, data, afterPerform) => {
  axios
    .put(url + `/shipment/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const deleteTracking = (orderId, trackingId, afterPerform) => {
  axios
    .delete(url + `/order/tracking/${orderId}/${trackingId}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const deleteCategory = (id, afterPerform) => {
  axios
    .delete(url + `/category/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const deleteMaterial = (id, afterPerform) => {
  axios
    .delete(url + `/material/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateOrderItem = (orderId, itemId, data, afterPerform) => {
  axios
    .put(url + `/order/item/${orderId}/${itemId}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const cancelDelivery = (id, afterPerform) => {
  axios
    .delete(url + `/delivery/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const cancelDeliveryV2 = (id, afterPerform) => {
  axios
    .delete(url + `/v2/invoice/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const completeInvoiceV2 = (id, afterPerform) => {
  axios
    .put(url + `/v2/invoice/complete/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const sendOnDelivery = (id, afterPerform) => {
  axios
    .put(url + `/v2/invoice/on-delivery/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateDeliveryInvoice = (id, data, afterPerform) => {
  axios
    .put(url + `/delivery/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const assignCustomer = (data, afterPerform) => {
  axios
    .put(url + `/bookings/assign/customer`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(getError(err));
      afterPerform(false, getError(err));
    });
};

export const getPaymentTransactions = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/payments` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPaymentTransactionsV2 = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/v2/payments` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getShipments = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipments` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getAllocationShipments = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/allocation/available-shipments` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCartons = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/cartons` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getMultiCartons = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/allocation/multicartons` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getUnknownBookings = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/bookings/unknown` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getUnReceivedBookings = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/bookings/unreceived` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getQCBookings = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/qc/bookings` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getAllocationCartons = (id, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/allocation/available-cartons/${id}` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getShipmentCartons = (id, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipment/cartons/${id}` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getShipmentBooking = (id, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipment/bookings/${id}` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getCartonBooking = (id, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/carton/bookings/${id}` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getShipment = (id, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipment/${id}` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getMetas = (type, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/metas${type ? "/" + type : ""}` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const updateMeta = (id, data, afterPerform) => {
  axios
    .put(url + `/meta/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(getError(err));
      afterPerform(false, getError(err));
    });
};

export const updateCartonCbm = (id, data, afterPerform) => {
  axios
    .put(url + `/carton/cbm/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(getError(err));
      afterPerform(false, getError(err));
    });
};

export const deleteCarton = (id, afterPerform) => {
  axios
    .delete(url + `/carton/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getSortingList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/sorting/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getSheet = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/sheet` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getOrder = (setData, id) => {
  axios
    .get(url + `/order/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getBooking = (setData, id) => {
  axios
    .get(url + `/booking/${id}`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const updateCustomer = (id, data, afterPerform) => {
  axios
    .put(url + `/customer/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(getError(err));
      afterPerform(false, getError(err));
    });
};

export const addAdmin = (data, afterPerform) => {
  axios
    .post(url + `/admin`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addAssessment = (data, afterPerform) => {
  axios
    .post(url + `/cnf/assessment`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addCustomer = (data, afterPerform) => {
  axios
    .post(url + `/customer`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addCategory = (data, afterPerform) => {
  axios
    .post(url + `/category`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addHsCode = (data, afterPerform) => {
  axios
    .post(url + `/hscode`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addMaterial = (data, afterPerform) => {
  axios
    .post(url + `/material`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const initiateCashPayment = (data, afterPerform) => {
  axios
    .post(url + `/payment/initiate/cash`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const completeDelivery = (id, afterPerform) => {
  axios
    .put(url + `/delivery/complete/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addCoupon = (data, afterPerform) => {
  axios
    .post(url + `/coupon`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const completeSorting = (id, data, afterPerform) => {
  axios
    .put(url + `/order/sorting/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const removeLogistic = (orderId, logisticId, afterPerform) => {
  axios
    .delete(url + `/order/sorting/${orderId}/${logisticId}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const createShipment = (data, afterPerform) => {
  axios
    .post(url + `/shipment`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const createCarton = (data, afterPerform) => {
  axios
    .post(url + `/carton`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addOrderNote = (data, afterPerform) => {
  axios
    .put(url + `/booking/note/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};
export const purchaseCompleteBD = (data, afterPerform) => {
  axios
    .put(url + `/order/purchase/bd/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const purchaseCompleteCN = (data, afterPerform) => {
  axios
    .put(url + `/order/purchase/cn/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateOrderStatus = (data, afterPerform) => {
  axios
    .put(url + `/booking/status/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateShippingCharge = (data, afterPerform) => {
  axios
    .put(url + `/v2/booking/shipping-rate/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateBookingExtraCharge = (bookingId, data, afterPerform) => {
  axios
    .put(url + `/v2/booking/extra-charge/${bookingId}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateDeliveryBookingWeight = (data, afterPerform) => {
  axios
    .put(url + `/booking/weight/${data.booking_id}/${data.log_id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateDeliveryBookingWeightV2 = (data, afterPerform) => {
  axios
    .put(
      url + `/v2/booking/logistic-weight/${data.booking_id}/${data.log_id}`,
      data,
    )
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateReceivedWeight = (data, afterPerform) => {
  axios
    .put(url + `/booking/received-weight/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updatePayablePercentage = (data, afterPerform) => {
  axios
    .put(url + `/order/payable/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateAdmin = (id, data, afterPerform) => {
  axios
    .put(url + `/admin/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateCategory = (id, data, afterPerform) => {
  axios
    .put(url + `/category/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateHsCode = (id, data, afterPerform) => {
  axios
    .put(url + `/hscode/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateBookingCategory = (id, data, afterPerform) => {
  axios
    .put(url + `/booking/category/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateMaterial = (id, data, afterPerform) => {
  axios
    .put(url + `/material/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateInvoice = (id, data, afterPerform) => {
  axios
    .put(url + `/delivery/invoice/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateCoupon = (id, data, afterPerform) => {
  axios
    .put(url + `/coupon/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getReport = (setData, type) => {
  axios
    .get(url + `/report/summary/${type}`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getOrderStats = (setData) => {
  axios
    .get(url + `/report/orderstatus/stats`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const resolveQC = (id, afterPerform) => {
  axios
    .put(url + `/qc/booking/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(getError(err));
      afterPerform(false, getError(err));
    });
};

export const submitOfficePayment = (data, afterPerform) => {
  axios
    .post(url + `/v2/invoice/payment/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const createCall = (data, afterPerform) => {
  axios
    .post(url + `/call`, data)
    .then((res) => {
      afterPerform(
        true,
        res.data?.data?.message || "Call recorded successfully",
        res.data?.data?.call,
      );
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getCalls = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/calls` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCustomerBadgeStats = (setData) => {
  axios
    .get(url + `/report/customer/badge/stats`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
